// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__uoHnM","header":"Header_header__2Npb4"};